module.exports = __webpack_public_path__ + "img/goods12-7.8e30674b.jpg";